module.exports = __webpack_public_path__ + "img/pr-19.cda61911.png";